import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  _ImoTermCount,
  _ImoTermSearch,
  ImoCountResultDto,
  ImoSearchResultDto,
  ImoTermDto,
  ImoTermInputDto,
  ImoTermResultDto
} from 'webcommon/shared';
import { PrmHttpClientService } from '../PrmHttpClientService';

// this calls the same endpoints as ImoDiagnosisRepository.js
@Injectable({
  providedIn: 'root',
})
export class ImoProblemService {
  constructor(
    private readonly httpClientService: PrmHttpClientService,
  ) { }

  search(config: _ImoTermSearch): Observable<ImoSearchResultDto> {
    const endpointUrl = `imo-problem/terms`;
    const params = new HttpParams({
      fromObject: config as any,
    });
    return this.httpClientService.sendGetRequest(endpointUrl, params);
  }

  terms(lexicalCodes: string[]): Observable<ImoTermResultDto> {
    const endpointUrl = `imo-problem/terms`;
    const params = new HttpParams({
      fromObject: {
        LexicalCodes: lexicalCodes,
      } satisfies Partial<ImoTermInputDto>,
    });
    return this.httpClientService.sendGetRequest(endpointUrl, params);
  }

  count(config: _ImoTermCount): Observable<ImoCountResultDto> {
    const endpointUrl = `imo-problem/terms`;
    config.CountOnly = true;
    const params = new HttpParams({
      fromObject: config as any,
    });
    return this.httpClientService.sendGetRequest(endpointUrl, params);
  }

  term(lexicalCode: string): Observable<ImoTermDto> {
    const endpointUrl = `imo-problem/terms/${lexicalCode}`;
    return this.httpClientService.sendGetRequest(endpointUrl);
  }

  //... there's still some endpoints not implemented here, but they aren't used anywhere currently
}
